import viewerUserPreferences from 'models/user/ViewerUserPreferences';
import AsyncFeatureFlag from 'utils/AsyncPreference';
import { blockInAccountSharingReadonly } from 'system/SystemUtil';
import {
    highResolutionData,
    reactActivityListPageRoleKey,
    reactWorkoutsListPageRoleKey //Cleanup ticket: CA-195366
} from 'models/preferences/PreferencesMapping';
import viewerSocialProfile from '../models/user/ViewerSocialProfile';
import ReactComponentPageView from '../views/main/react/ReactComponentPageView';
import ConnectLoadable from '../../components/ConnectLoadable';
import NavigationUtil from 'utils/NavigationUtil';

var view = null;

Window.App.workouts = async function() {
    const isWorkoutsListEnabledByFeatureFlagRole = await AsyncFeatureFlag.isFeatureEnabled(
        reactWorkoutsListPageRoleKey
    );

    if (isWorkoutsListEnabledByFeatureFlagRole) {
        Window.App.displayPage(
            new ReactComponentPageView({
                page: ConnectLoadable(() => import('Workouts/WorkoutsListPage'))
            })
        );
    } else {
        import('pages/workouts/WorkoutListPageView').then(({ default: WorkoutListPageView }) => {
            var view = new WorkoutListPageView({
                userPreferences: viewerUserPreferences,
                id: new Date().getTime()
            });

            Window.App.displayPage(view);
        });
    }
};

Window.App.singleDevice = function(deviceId, update) {
    var _this = this;
    import('pages/device/SingleDevice').then(({ default: SingleDevicePageView }) => {
        var singleDevicePageView = new SingleDevicePageView({
            deviceId: deviceId,
            userPreferences: _this.userPreferences,
            ownerDisplayName: _this.displayName,
            showUpdate: window.location.href.indexOf('update') !== -1 || (update && update === 'update'),
            showUsers: window.location.href.indexOf('users') !== -1 || (update && update === 'users'),
            chooseUserSettingsTab: window.location.href.indexOf('settings') !== -1 || (update && update === 'settings')
        });

        _this.displayPage(singleDevicePageView);
    });
};

Window.App.deviceWeightScaleGetStarted = function(deviceId, inviteId) {
    // We require the view here, rather than in the define() above. This is to ensure a lightweight
    // router that downloads its resources on demand.
    var _this = this;
    if (!_this.viewerIsAuthenticated) {
        import('views/device/DeviceInviteLoginView').then(({ default: DeviceInviteLoginView }) => {
            var deviceInviteLoginView = new DeviceInviteLoginView({});
            _this.displayPage(deviceInviteLoginView);
        });
    } else {
        import('pages/device/DeviceWeightScaleGetStarted').then(({ default: DeviceWeightScaleGetStarted }) => {
            var deviceWeightScaleGetStarted = new DeviceWeightScaleGetStarted({
                userPreferences: _this.userPreferences,
                displayName: _this.displayName,
                deviceId: deviceId,
                inviteId: inviteId,
                isPrimaryUser: false
            });

            _this.displayPage(deviceWeightScaleGetStarted);
        });
    }
};

Window.App.deviceWeightScalePrimaryUserInfo = function(serialNumber) {
    // We require the view here, rather than in the define() above. This is to ensure a lightweight
    // router that downloads its resources on demand.
    var _this = this;
    import('pages/device/DeviceWeightScaleGetStarted').then(({ default: DeviceWeightScaleGetStarted }) => {
        var deviceWeightScaleGetStarted = new DeviceWeightScaleGetStarted({
            userPreferences: _this.userPreferences,
            displayName: _this.displayName,
            isPrimaryUser: true,
            serialNumber: serialNumber,
            isIndex1: true
        });

        _this.displayPage(deviceWeightScaleGetStarted);
    });
};

Window.App.deviceWeightScalePrimaryGetStarted = function() {
    // We require the view here, rather than in the define() above. This is to ensure a lightweight
    // router that downloads its resources on demand.
    var _this = this;
    import('pages/device/DeviceWeightScalePrimaryGetStarted').then(
        ({ default: DeviceWeightScalePrimaryGetStarted }) => {
            var deviceWeightScaleGetStarted = new DeviceWeightScalePrimaryGetStarted({
                userPreferences: _this.userPreferences,
                displayName: _this.displayName
            });

            _this.displayPage(deviceWeightScaleGetStarted);
        }
    );
};

/*
    TODO: 
    CA-181526:
    - Add redirects in fitness.js when the new Training Plans page is almost done
    - Send anyone with ROLE_MBTESTER to /training-plan-new
    - > can't do that beforehand since those accounts would be forced to the new page while it's under construction
    - With the redirect in place, we can toggle between new and old using the preference flag
    CA-181529:
    - Update /training-plan-new to /training-plan in routes.js
    - Update /explore/training-plan to /training-plan/FindAPlan in ATPStateMessage.jsx
    - > this will allow the deletion of exploreTrainingPlan since that route is just meant to land on the Find A Plan tab
    - Delete the now unused Backbone routes from fitness.js
*/
Window.App.exploreTrainingPlan = async function() {
    import('pages/training_plans/TrainingPlansPageView').then(({ default: TrainingPlansPageView }) => {
        var trainingPlanPageView = new TrainingPlansPageView({
            userPreferences: viewerUserPreferences,
            activeTab: 'FindAPlan'
        });

        Window.App.displayPage(trainingPlanPageView);
    });
};

Window.App.trainingPlan = async function() {
    import('pages/training_plans/TrainingPlansPageView').then(({ default: TrainingPlansPageView }) => {
        var trainingPlanPageView = new TrainingPlansPageView({
            userPreferences: viewerUserPreferences
        });

        Window.App.displayPage(trainingPlanPageView);
    });
};

Window.App.activities = async function(queryString) {
    const viewerSocialProfileJson = viewerSocialProfile.toJSON();
    const viewerUserPreferencesJson = viewerUserPreferences.toJSON();
    const isActivityListEnabledByFeatureFlagRole = await AsyncFeatureFlag.isFeatureEnabled(
        reactActivityListPageRoleKey
    );

    if (isActivityListEnabledByFeatureFlagRole) {
        Window.App.displayPage(
            new ReactComponentPageView({
                page: ConnectLoadable(() => import('ActivityList/ActivityListPage')),
                viewerSocialProfile: viewerSocialProfileJson,
                viewerUserPreferences: viewerUserPreferencesJson
            })
        );
    } else {
        //old backbone page
        import('pages/activities/ActivityListPageView').then(({ default: ActivityListPageView }) => {
            const activityListPageView = new ActivityListPageView({
                userPreferences: viewerUserPreferences,
                queryString: queryString
            });

            Window.App.displayPage(activityListPageView);
        });
    }
};

Window.App.activityDetail = async function(activityId, childId, commentId) {
    var _this = this;

    const isHighResolutionDataEnabled = await AsyncFeatureFlag.isFeatureEnabled(highResolutionData);

    import('pages/activity_details_2/ActivityPageView').then(({ default: ActivityPageView }) => {
        if (childId && childId.indexOf('share_unique_id=') === 0) {
            childId = undefined;
        }

        if (commentId && commentId.indexOf('share_unique_id=') === 0) {
            commentId = undefined;
        }

        var index = childId && childId.length > 0 ? childId.indexOf('?') : -1;
        var childIdValue = index != -1 ? childId.substr(0, index) : childId;
        if (view && typeof view.destroy === 'function') {
            view.destroy();
        }
        if (childId && childId.indexOf('fullscreen=true') !== -1) {
            childIdValue = undefined;
        }

        view = new ActivityPageView({
            userPreferences: viewerUserPreferences,
            id: new Date().getTime(),
            activityId: activityId,
            childId: childIdValue ? childIdValue : undefined,
            commentId: commentId,
            viewerIsAuthenticated: _this.viewerIsAuthenticated,
            isHighResolutionDataEnabled: isHighResolutionDataEnabled
        });

        Window.App.displayPage(view);
    });
};

Window.App.activityChildDetail = function(activityId, childActivityId) {
    import('models/activity/FlatActivitySummary').then(async ({ default: Activity }) => {
        const activity = new Activity({ activityId: activityId });
        await activity.fetch({ async: false });

        const children = activity.get('childIds');
        let childIndex = 0;

        if (children && children.length > 0) {
            childIndex =
                children.findIndex((child) => {
                    return child == childActivityId;
                }) + 1; // add one because child activities are 1-indexed elsewhere in code
        }
        const url = '/activity/' + activityId + '/' + childIndex;

        Window.App.navigate(url, { trigger: true, replace: true });
    });
};

Window.App.manualActivity = function(activityId, mode) {
    import('pages/activity_details_2/activity_edit/EditActivityPageView').then(({ default: EditActivityPageView }) => {
        var queryString = location.search || null;
        var autoActivityEvent = {};
        var keyValuePair = [];

        if (queryString !== null) {
            // Turn the query string into an object where key/value pairs become decoded property/value pairs
            queryString
                .replace('?', '')
                .split('&')
                .map(function(param) {
                    keyValuePair = param.split('=');
                    autoActivityEvent[decodeURIComponent(keyValuePair[0])] = decodeURIComponent(keyValuePair[1]);
                });
        }

        var editActivityPageView = new EditActivityPageView({
            userPreferences: viewerUserPreferences,
            id: new Date().getTime(),
            activityId: activityId,
            mode: mode,
            autoActivityEvent: autoActivityEvent
        });

        Window.App.displayPage(editActivityPageView);
    });
};

Window.App.advancedActivityEdit = function(activityId) {
    import('pages/advanced_activity_edit/AdvancedActivityEditPageView').then(
        ({ default: AdvancedActivityEditPageView }) => {
            var advancedActivityEditPageView = new AdvancedActivityEditPageView({
                userPreferences: viewerUserPreferences,
                activityId: activityId
            });

            Window.App.displayPage(advancedActivityEditPageView);
        }
    );
};

Window.App.activityIntervalsEdit = function(activityId) {
    import('pages/activity_intervals_edit/EditActivityIntervalsPageView').then(
        ({ default: EditActivityIntervalsPageView }) => {
            var editActivityIntervalsPageView = new EditActivityIntervalsPageView({
                userPreferences: viewerUserPreferences,
                activityId: activityId
            });

            Window.App.displayPage(editActivityIntervalsPageView);
        }
    );
};

Window.App.activityEmbed = function(activityId) {
    Window.App.displayEmbed(
        new ReactComponentPageView({
            page: ConnectLoadable(() => import('components/ActivityDetails/ActivityEmbed/ActivityEmbed')),
            pageClassName: 'content',
            activityId: activityId
        })
    );
};

Window.App.activitySync = function(activeTab) {
    var _this = this;
    import('pages/activity_sync/ActivitySyncPageView').then(({ default: ActivitySyncPageView }) => {
        var view = new ActivitySyncPageView({
            userPreferences: _this.userPreferences,
            activeTab: activeTab ? activeTab : ''
        });

        _this.displayPage(view);
    });
};

Window.App.stravaSegments = function() {
    var _this = this;
    import('pages/segments/StravaSegmentsPageView').then(({ default: StravaSegmentsPageView }) => {
        var view = new StravaSegmentsPageView({
            userPreferences: _this.userPreferences
        });

        _this.displayPage(view);
    });
};

Window.App.noPrivileges = function() {
    var _this = this;
    import('pages/privileges/NoPrivilegesPageView').then(({ default: NoPrivilegesPageView }) => {
        var view = new NoPrivilegesPageView({
            userPreferences: _this.userPreferences,
            id: new Date().getTime(),
            authTypeKey: '',
            viewerIsAuthenticated: _this.viewerIsAuthenticated
        });

        _this.displayPage(view);
    });
};

Window.App.viewSegment = function(queryString) {
    var _this = this;
    Promise.all([import('backbone'), import('utils/NavigationUtil')]).then(
        ([{ default: Backbone }, { default: NavigationUtil }]) => {
            if (queryString.indexOf('url=') > -1) {
                var segmentUrl = queryString.substring(4);
                Backbone.history.navigate(segmentUrl, { trigger: true });
            } else {
                NavigationUtil.displayPageNotFoundPage();
            }
        }
    );
};

Window.App.route('workouts', 'workouts');
Window.App.route('device/:deviceId(/:update)', 'singleDevice');
Window.App.route('device/:deviceId(/:tab)', 'singleDevice');
Window.App.route('device/primary-get-started', 'deviceWeightScalePrimaryGetStarted');
Window.App.route('device/primary-get-started/:serialNumber/user-info', 'deviceWeightScalePrimaryUserInfo');
Window.App.route('device/get-started/:deviceId/invite/:inviteId', 'deviceWeightScaleGetStarted');
Window.App.route('device/get-started/:deviceId/invite/:inviteId', 'deviceWeightScaleGetStarted');

Window.App.route('explore/training-plan', 'exploreTrainingPlan');
Window.App.route('training-plan', 'trainingPlan');

Window.App.route('activities', 'activities');

Window.App.route('activity/:activityId/child/:childActivityId', 'activityChildDetail');
Window.App.route('activity/:activityId', 'activityDetail');
Window.App.route('activity/:activityId/edit/advanced', 'advancedActivityEdit');
Window.App.route('activity/:activityId/edit/intervals', 'activityIntervalsEdit');
Window.App.route('activity/:activityId/share/:isGarminLogo', 'activityDetail');
Window.App.route('activity/:activityId/(:childId/)comment/:commentId', 'activityDetail');
Window.App.route('activity/:activityId/:childId', 'activityDetail');
Window.App.route('activity/embed/:activityId', 'activityEmbed');
Window.App.route('activity/manual/:activityId/:mode', 'manualActivity');
Window.App.route('activity/manual/full', 'manualActivity');
Window.App.route('activity/manual', 'manualActivity');

Window.App.route('segments/strava', 'stravaSegments');

Window.App.route('user-exceptions', 'userExceptions');

Window.App.route('system/:page', 'system');
Window.App.route('activity-sync', 'activitySync');
Window.App.route('activity-sync/:activeTab', 'activitySync');

Window.App.route('noPrivileges', 'noPrivileges');
Window.App.route('segment-authenticate/request?*url', 'viewSegment');

Window.App.route('8f64af9k27s4v62b397g285', '8f64af9k27s4v62b397g285'); // Intelligent training plan page
